/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Portfolio_LinkInputs */

const en_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`my portfolio`)
};

const ar_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرض أعمالي`)
};

const bn_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমার পোর্টফোলিও`)
};

const de_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mein Portfolio`)
};

const es_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mi cartera`)
};

const fr_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mon portefeuille`)
};

const pt_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meu portfólio`)
};

const zh_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的投资组合`)
};

const tr_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portföyüm`)
};

const ru_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мое портфолио`)
};

const pl_resume_portfolio_link = /** @type {(inputs: Resume_Portfolio_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moje portfolio`)
};

/**
* | output |
* | --- |
* | "my portfolio" |
*
* @param {Resume_Portfolio_LinkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_portfolio_link = /** @type {((inputs?: Resume_Portfolio_LinkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Portfolio_LinkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_portfolio_link(inputs)
	if (locale === "bn") return bn_resume_portfolio_link(inputs)
	if (locale === "de") return de_resume_portfolio_link(inputs)
	if (locale === "es") return es_resume_portfolio_link(inputs)
	if (locale === "fr") return fr_resume_portfolio_link(inputs)
	if (locale === "pt") return pt_resume_portfolio_link(inputs)
	if (locale === "zh") return zh_resume_portfolio_link(inputs)
	if (locale === "tr") return tr_resume_portfolio_link(inputs)
	if (locale === "ru") return ru_resume_portfolio_link(inputs)
	if (locale === "pl") return pl_resume_portfolio_link(inputs)
	return en_resume_portfolio_link(inputs)
});